import { render, staticRenderFns } from "./EducationCarrers.vue?vue&type=template&id=258799d2"
import script from "./EducationCarrers.vue?vue&type=script&lang=js"
export * from "./EducationCarrers.vue?vue&type=script&lang=js"
import style0 from "./EducationCarrers.vue?vue&type=style&index=0&id=258799d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports